module.exports = __webpack_public_path__ + "img/sampdoria1.607688f4.jpg";